import { render, staticRenderFns } from "./StudentManagement.vue?vue&type=template&id=a46ae20c&scoped=true"
import script from "./StudentManagement.vue?vue&type=script&lang=js"
export * from "./StudentManagement.vue?vue&type=script&lang=js"
import style0 from "./StudentManagement.vue?vue&type=style&index=0&id=a46ae20c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46ae20c",
  null
  
)

export default component.exports